<div class="grid-wrapper grid-simple w-100 h-100">
  <ag-grid-angular class="grid-element ag-theme-alpine w-100 h-100"
                   [gridOptions]="gridOptions"
                   (gridReady)="onGridReady($event)"
                   (cellClicked)="onCellClicked($event)"
                   [components]="components"
                   [headerHeight]="headerHeight()"
                   [rowHeight]="rowHeight()"
                   (modelUpdated)="onModelUpdated($event)"
                   (filterChanged)="onFilterChanged($event)">
  </ag-grid-angular>
</div>